import { useMount, useUnmount } from 'ahooks';
import { lockScreen, unlockScreen } from './modals/ScreenLock';

/**
 * This component is intended to be used as fallback when using lazy components
 * in React. If you are looking for a way to lock or unlock the screen from
 * within a component. Please refer to the thook useScreenLock.
 *
 * If you are looking for a way to lock or unlock the screen from outside a
 * component, please refer to lockScreen.
 *
 * @see lockScreen
 * @see useScreenLock
 * @see forceLockScreen
 */
const ScreenLockSuspense = () => {
  useMount(() => {
    lockScreen();
  });
  useUnmount(() => {
    unlockScreen();
  });
  return null;
};

export default ScreenLockSuspense;
